import { CommerceStatus } from '../enums';

export const cleanPayload = <T extends Record<string, any>>(
  data: T
): Partial<T> => {
  const cleaned: Partial<T> = {};

  Object.keys(data).forEach((key) => {
    const value = data[key];

    if (value !== '' && value !== undefined && value !== null) {
      if (typeof value === 'string' && value.trim() !== '') {
        cleaned[key as keyof T] = value.trim() as T[keyof T];
      } else if (typeof value !== 'string') {
        cleaned[key as keyof T] = value;
      }
    }
  });

  return cleaned;
};

export const cleanCommercePayload = (data: {
  name?: string;
  businessName?: string;
  taxNumber?: string;
  status?: CommerceStatus;
  externalId?: string;
  businessKey?: string;
  stateId?: string;
  cityId?: string;
  neighborhoodId?: string;
  streetName?: string;
  doorNumber?: string;
  apartmentNumber?: string;
  corner?: string;
  logo?: string;
  url?: string;
  email?: string;
  commerceGroupId?: string;
}): {
  name: string;
  businessName: string;
  taxNumber?: string;
  status: CommerceStatus;
  externalId: string;
  businessKey?: string;
  neighborhoodId: string;
  cityId?: string;
  streetName: string;
  doorNumber: string;
  apartmentNumber?: string;
  corner?: string;
  logo?: string;
  url?: string;
  email?: string;
  commerceGroupId?: string;
} => {
  const result: any = {
    name: data.name?.trim() || '',
    businessName: data.businessName?.trim() || '',
    status: data.status || CommerceStatus.CREATED,
    externalId: data.externalId?.trim() || '',
    neighborhoodId: data.neighborhoodId?.trim() || '',
    streetName: data.streetName?.trim() || '',
    doorNumber: data.doorNumber?.trim() || '',
  };

  if (data.cityId && data.cityId.trim() !== '') {
    result.cityId = data.cityId.trim();
  }

  if (data.taxNumber && data.taxNumber.trim() !== '') {
    result.taxNumber = data.taxNumber.trim();
  }

  if (data.businessKey && data.businessKey.trim() !== '') {
    result.businessKey = data.businessKey.trim();
  }

  if (data.apartmentNumber && data.apartmentNumber.trim() !== '') {
    result.apartmentNumber = data.apartmentNumber.trim();
  }

  if (data.corner && data.corner.trim() !== '') {
    result.corner = data.corner.trim();
  }

  if (data.logo && data.logo.trim() !== '') {
    result.logo = data.logo.trim();
  }

  if (data.url && data.url.trim() !== '') {
    result.url = data.url.trim();
  }

  if (data.email && data.email.trim() !== '') {
    result.email = data.email.trim();
  }

  if (data.commerceGroupId && data.commerceGroupId.trim() !== '') {
    result.commerceGroupId = data.commerceGroupId.trim();
  }

  return result;
};

export const isValidUUID = (value: string): boolean => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(value);
};

export const formatTaxNumber = (taxNumber: string): string => {
  if (!taxNumber || taxNumber.length < 8) return taxNumber;

  const cleaned = taxNumber.replace(/\D/g, '');
  if (cleaned.length === 12) {
    return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 9)}-${cleaned.slice(9)}`;
  }

  return taxNumber;
};

export const isValidTaxNumber = (taxNumber: string): boolean => {
  const cleaned = taxNumber.replace(/\D/g, '');
  return cleaned.length === 12 && /^\d{12}$/.test(cleaned);
};
